<template>
  <div class="app-container">
    <el-row>
      <ul style="float:left;list-style:none;padding:0px;margin-top:0px">
        <li>
          <span style="font-weight:bold;">{{ $t('fabricOrder.orderNumber') + ':' }}</span>
          {{ orderNumber }}
        </li>
        <li>
          <span style="font-weight:bold;">{{ $t('common.lineNumber') + ':' }}</span>
          {{ lineNumber }}
        </li>
        <li>
          <span style="font-weight:bold;">{{ $t('common.articleNumber') + ':' }}</span>
          {{ articleNumber }}
        </li>
      </ul>
      <editor-button :loading="loading" action="cancel" style="float:right" @click="handleClose" />
      <editor-button
        :icon-only="false"
        :loading="loading"
        button-translation="common.save"
        action="primary"
        style="float:right;"
        @click="saveSelection()"
      />
      <editor-button
        :icon-only="false"
        :loading="loading"
        button-translation="common.prefill"
        action="primary"
        style="float:right;"
        @click="prefill()"
      />
    </el-row>
    <el-table v-loading="loading" :data="items" border fit highlight-current-row style="width: 100%">
      <el-table-column label-class-name="filter-cell">
        <template slot="header" slot-scope="{}"> </template>
        <el-table-column :label="$t('common.palletNumber')">
          <template slot-scope="scope">
            <span>{{ scope.row['palletNumber'] }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label-class-name="filter-cell">
        <template slot="header" slot-scope="{}"> </template>
        <el-table-column :label="$t('fabricOrder.orderedQuantity')">
          <template slot-scope="scope">
            <span>{{ scope.row['quantityOrderedInMeters'] }}</span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label-class-name="filter-cell">
        <template slot="header" slot-scope="{}"> </template>
        <el-table-column :label="$t('fabricOrder.deliveredQuantity')">
          <template slot-scope="{ row }">
            <MDinput
              v-model="row.quantityDeliveredInMeters"
              type="number"
              :precision="2"
              :min="0"
              placeholder="common.fillInANumber"
            />
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import EditorButton from '@/components/crud/EditorButton';
import MDinput from '@/components/MDinput';
import { closeCurrentTag } from '@/utils/tags';
export default {
  name: 'EditFabricRolls',
  components: {
    EditorButton,
    MDinput
  },
  data() {
    return {
      items: [],
      loading: false,
      fabricOrderID: 0,
      fabricOrderLineID: 0,
      articleNumber: '',
      lineNumber: null,
      orderNumber: ''
    };
  },
  created() {
    this.fabricOrderLineID = +this.$route.params.id;
    this.refreshList();
  },
  methods: {
    handleClose() {
      const id = this.fabricOrderID;
      const next = { name: 'EditFabricOrder', params: { id }, query: { tab: 'line-items' } };
      closeCurrentTag(this, next);
    },
    prefill() {
      if (!this.items) {
        return;
      }
      this.items.forEach(item => {
        if (!item.quantityDeliveredInMeters) {
          item.quantityDeliveredInMeters = item.quantityOrderedInMeters;
        }
      });
    },
    refreshList() {
      if (!this.fabricOrderLineID) {
        return;
      }
      this.loading = true;
      this.$store
        .dispatch('fabricOrderLine/getRolls', {
          fabricOrderLineID: this.fabricOrderLineID
        })
        .then(data => {
          this.fabricOrderID = data.fabricOrderID;
          this.articleNumber = data.articleNumber;
          this.lineNumber = data.lineNumber;
          this.orderNumber = data.orderNumber;
          this.items = data.rollsOfFabric;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveSelection() {
      if (!this.items || this.items.length === 0) {
        return;
      }
      const saveCommand = {
        fabricOrderLineID: this.fabricOrderLineID,
        rolls: this.items.map(i => ({
          palletNumber: i.palletNumber,
          quantityDeliveredInMeters: i.quantityDeliveredInMeters || 0
        }))
      };
      this.$store
        .dispatch('fabricOrderLine/saveRolls', saveCommand)
        .then(data => {
          this.$store.dispatch('notify/success', { message: this.$i18n.t('common.data_updated') });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
